import { render, staticRenderFns } from "./document-tracks.vue?vue&type=template&id=4c7e3f2c&"
import script from "./document-tracks.vue?vue&type=script&lang=js&"
export * from "./document-tracks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports